// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { VariableDO } from '../../../requests';

interface Props {
  formValues: {
    data: Partial<VariableDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { data } = props.formValues;
  const isNew: boolean = (data.id === undefined || isNaN(data.id));

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Code</b> &nbsp;{' '}
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.value || ''}
            name="value"
            onChange={props.onChange}
            required
            readOnly={!isNew}
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Unit</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.unit || ''}
            name="unit"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-3">
          <label className="label">
             &nbsp;
          </label>
          <input
            className="inputNew"
            type="checkbox"
            name="graph"
            checked={data.graph || false}
            onChange={props.onChange}
          />
          &nbsp;&nbsp;
          <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            Plottable
          </label>
        </div>
        <div className="col-3">
          <label className="label">
             &nbsp;
          </label>
          <input
            className="inputNew"
            type="checkbox"
            name="alarm"
            checked={data.alarm || false}
            onChange={props.onChange}
          />
          &nbsp;&nbsp;
          <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            Allow Alarm
          </label>
        </div>
      </div>
    </fieldset>
  );
}
